module.exports = __webpack_public_path__ + "static/media/edit.756fc5a2.svg";